// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"CheckinUserScreen_contentSection__1jhg_","logo":"CheckinUserScreen_logo__ScqL3"};